import React from "react";
import { getEcoConsumptionDisclaimerIndex } from "../utils/ecoConsumptionConfigurationUtils";
import {
    type EcoConsumptionAreaType,
    type EcoConsumptionSectionType,
    EcoConsumptionAreaEnum,
} from "../types/EcoConsumptionType";
import { FuelEcoConsumptionArea } from "./FuelEcoConsumptionArea";
import { SpecEcoConsumptionArea } from "./SpecEcoConsumptionArea";
import { EmissionEcoConsumptionArea } from "./EmissionEcoConsumptionArea";
import { CostsEcoConsumptionArea } from "./CostsEcoConsumptionArea";
import { DisclaimerEcoConsumptionArea } from "./DisclaimerEcoConsumptionArea";

const getEcoConsumptionAreaComponent = (
    ecoConsumptionArea: EcoConsumptionAreaType,
    ecoConsumptionConfiguration: EcoConsumptionSectionType,
    PopoverTooltip?: (props: { content: string }) => JSX.Element,
): JSX.Element | null => {
    switch (ecoConsumptionArea.type) {
        case EcoConsumptionAreaEnum.FuelArea:
            return <FuelEcoConsumptionArea {...ecoConsumptionArea} />;
        case EcoConsumptionAreaEnum.SpecArea:
            return (
                <SpecEcoConsumptionArea
                    {...ecoConsumptionArea}
                    getDisclaimerIndex={(disclaimer) =>
                        getEcoConsumptionDisclaimerIndex(disclaimer, ecoConsumptionConfiguration)
                    }
                    PopoverTooltip={PopoverTooltip}
                />
            );
        case EcoConsumptionAreaEnum.EmissionArea:
            return <EmissionEcoConsumptionArea {...ecoConsumptionArea} />;

        case EcoConsumptionAreaEnum.CostsArea:
            return (
                <CostsEcoConsumptionArea
                    {...ecoConsumptionArea}
                    getDisclaimerIndex={(disclaimer) =>
                        getEcoConsumptionDisclaimerIndex(disclaimer, ecoConsumptionConfiguration)
                    }
                />
            );
        case EcoConsumptionAreaEnum.DisclaimerArea:
            return <DisclaimerEcoConsumptionArea {...ecoConsumptionArea} />;
        default:
            return null;
    }
};

const EcoConsumptionSection: React.FC<{
    ecoConsumptionConfiguration: EcoConsumptionSectionType;
    PopoverTooltip?: (props: { content: string }) => JSX.Element;
}> = ({ ecoConsumptionConfiguration, PopoverTooltip }) => {
    const { areas } = ecoConsumptionConfiguration;
    return (
        <>
            {areas.map((ecoConsumptionArea, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={`eco-consumption-${index}`}>
                    {getEcoConsumptionAreaComponent(ecoConsumptionArea, ecoConsumptionConfiguration, PopoverTooltip)}
                </React.Fragment>
            ))}
        </>
    );
};

export default EcoConsumptionSection;
